/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */



// =======================================================
// HOBIEGO — SPLIT SHIPPING (Option A) — UK ONLY
// Fee variant: 56318235509120
// Goal: NO cart:refresh (prevents flicker + stops "You may also like" refreshing)
// We manually:
//  - add/remove fee
//  - re-fetch cart.js
//  - sync split UI
//  - update totals (main cart + mini cart checkout total)
// =======================================================

(function () {
  const SPLIT_FEE_VARIANT_ID = 56318235509120;
  const UK_ISO = 'GB';

  // ---------- helpers ----------

  function isPreorderTitle(title = '') {
    const t = String(title || '')
      .toUpperCase()
      .replace(/\s+/g, ' ')
      .trim();

    return (
      t.startsWith('PRE-ORDER') ||
      t.startsWith('PREORDER') ||
      t.startsWith('PRE ORDER') ||
      /^[^A-Z0-9]*PRE[- ]?ORDER\b/.test(t)
    );
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  }

  function feeItem(cart) {
    return (cart.items || []).find((i) => Number(i.id) === Number(SPLIT_FEE_VARIANT_ID)) || null;
  }

  function hasFee(cart) {
    return !!feeItem(cart);
  }

  function cartIsMixed(cart) {
    let hasPre = false;
    let hasNonPre = false;

    (cart.items || []).forEach((item) => {
      if (Number(item.id) === Number(SPLIT_FEE_VARIANT_ID)) return;

      const title = (item.product_title || item.title || '');
      if (isPreorderTitle(title)) hasPre = true;
      else hasNonPre = true;
    });

    return hasPre && hasNonPre;
  }

  async function addFee() {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: SPLIT_FEE_VARIANT_ID, quantity: 1 })
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      console.error('[HOBIEGO Split Shipping] addFee failed:', res.status, txt);
      throw new Error('Failed to add split fee');
    }
  }

  async function removeFee(cart) {
    const fee = feeItem(cart);
    if (!fee) return;

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: fee.key, quantity: 0 })
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      console.error('[HOBIEGO Split Shipping] removeFee failed:', res.status, txt);
      throw new Error('Failed to remove split fee');
    }
  }

  function setRadiosDisabled(disabled) {
    document
      .querySelectorAll('[data-hobiego-split-wrap] input[name="hobiego_shipping_choice"]')
      .forEach((r) => (r.disabled = disabled));
  }

  function setWrapBusy(isBusy) {
    document.querySelectorAll('[data-hobiego-split-wrap]').forEach((wrap) => {
      if (isBusy) {
        wrap.dataset.hobiegoBusy = '1';
        wrap.hidden = false;
        wrap.style.opacity = '0.65';
        wrap.style.pointerEvents = 'none';
      } else {
        wrap.dataset.hobiegoBusy = '';
        wrap.style.opacity = '';
        wrap.style.pointerEvents = '';
      }
    });
  }

  function isUKWrapFromEventTarget(target) {
    const wrap = target && target.closest ? target.closest('[data-hobiego-split-wrap]') : null;
    if (!wrap) return false;
    return String(wrap.dataset.hobiegoCountry || '').toUpperCase() === UK_ISO;
  }

  function syncUI(cart) {
    const feePresent = hasFee(cart);
    const mixed = cartIsMixed(cart);

    document.querySelectorAll('[data-hobiego-split-wrap]').forEach((wrap) => {
      const country = String(wrap.dataset.hobiegoCountry || '').toUpperCase();

      if (country !== UK_ISO) {
        wrap.hidden = true;
        return;
      }

      const shouldShow = mixed || feePresent;

      // never hide while busy
      const busy = wrap.dataset.hobiegoBusy === '1';
      wrap.hidden = busy ? false : !shouldShow;

      const together = wrap.querySelector('[data-hobiego-ship-together]');
      const split = wrap.querySelector('[data-hobiego-split-ship]');

      if (together && split) {
        split.checked = feePresent;
        together.checked = !feePresent;
      }
    });
  }

  function formatMoney(cents, currency) {
    const cur = (currency || 'GBP').toUpperCase();
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: 2
      }).format((cents || 0) / 100);
    } catch (e) {
      return '£' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function updateCartPageTotal(cart) {
    const totalContainer = document.querySelector('.cart__total-container');
    if (!totalContainer) return;

    const spans = totalContainer.querySelectorAll('span');
    if (spans.length < 2) return;

    const money = formatMoney(cart.total_price, cart.currency);
    const code = (cart.currency || '').toUpperCase();
    spans[1].textContent = code ? `${money} ${code}` : money;
  }

  function updateMiniCartCheckoutTotal(cart) {
    const btn = document.querySelector('#mini-cart .checkout-button');
    if (!btn) return;

    const sep = btn.querySelector('.square-separator');
    if (!sep) return;

    const money = formatMoney(cart.total_price, cart.currency);
    const code = (cart.currency || '').toUpperCase();
    const text = code ? `${money} ${code}` : money;

    let node = sep.nextSibling;
    while (node && node.nodeType !== Node.TEXT_NODE) node = node.nextSibling;

    if (node && node.nodeType === Node.TEXT_NODE) {
      node.textContent = ' ' + text;
    } else {
      let span = btn.querySelector('[data-hobiego-mini-total]');
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('data-hobiego-mini-total', '');
        btn.appendChild(span);
      }
      span.textContent = ' ' + text;
    }
  }

  async function refreshMiniCartTotalFromServer(retries = 6) {
    for (let i = 0; i < retries; i++) {
      try {
        const cart = await getCart();
        updateMiniCartCheckoutTotal(cart);
        return;
      } catch (e) {}
      await new Promise((r) => setTimeout(r, 120));
    }
  }

  function makeThrottledRunner(fn) {
    let running = false;
    let queued = false;

    return async function runThrottled() {
      if (running) { queued = true; return; }
      running = true;
      queued = false;

      try { await fn(); }
      finally {
        running = false;
        if (queued) runThrottled().catch(() => {});
      }
    };
  }

  function hookMiniCartOpen() {
    const mini = document.getElementById('mini-cart');
    if (!mini) return;

    const run = makeThrottledRunner(async () => {
      const cart = await getCart();
      syncUI(cart);
      updateMiniCartCheckoutTotal(cart);
    });

    run().catch(() => {});

    const obsOpen = new MutationObserver(() => {
      if (mini.hasAttribute('open')) run().catch(() => {});
    });
    obsOpen.observe(mini, { attributes: true, attributeFilter: ['open'] });

    const obsDom = new MutationObserver(() => {
      if (mini.hasAttribute('open')) run().catch(() => {});
    });
    obsDom.observe(mini, { childList: true, subtree: true });
  }

  function hookMainCartRerender() {
    const isCartPage =
      document.body.classList.contains('template-cart') ||
      window.location.pathname === '/cart';

    if (!isCartPage) return;

    const root =
      document.querySelector('#MainContent') ||
      document.querySelector('main') ||
      document.querySelector('[data-section-type="cart"]') ||
      document.body;

    const run = makeThrottledRunner(async () => {
      const cart = await getCart();
      syncUI(cart);
      updateCartPageTotal(cart);
    });

    run().catch(() => {});
    new MutationObserver(() => run().catch(() => {})).observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('change', async (e) => {
    const el = e.target;
    if (!el || el.name !== 'hobiego_shipping_choice') return;

    try {
      if (!isUKWrapFromEventTarget(el)) return;

      setRadiosDisabled(true);
      setWrapBusy(true);

      let cart = await getCart();

      if (!cartIsMixed(cart)) {
        if (hasFee(cart)) await removeFee(cart);

        cart = await getCart();
        syncUI(cart);
        updateCartPageTotal(cart);
        updateMiniCartCheckoutTotal(cart);
        return;
      }

      if (el.value === 'split') {
        if (!hasFee(cart)) await addFee();
      } else {
        if (hasFee(cart)) await removeFee(cart);
      }

      cart = await getCart();
      syncUI(cart);
      updateCartPageTotal(cart);
      updateMiniCartCheckoutTotal(cart);

      await refreshMiniCartTotalFromServer();
    } catch (err) {
      console.error('[HOBIEGO Split Shipping] change handler error', err);
    } finally {
      setWrapBusy(false);
      setRadiosDisabled(false);
    }
  });

  const hbAutoCleanupOnCartUpdate = makeThrottledRunner(async (cartFromEvent) => {
    let cart = cartFromEvent || await getCart();

    if (!cartIsMixed(cart) && hasFee(cart)) {
      setWrapBusy(true);
      try {
        await removeFee(cart);
        cart = await getCart();
      } finally {
        setWrapBusy(false);
      }
    }

    syncUI(cart);
    updateCartPageTotal(cart);
    updateMiniCartCheckoutTotal(cart);
  });

  document.addEventListener('cart:updated', (event) => {
    hbAutoCleanupOnCartUpdate(event?.detail?.cart).catch(() => {});
  });

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const cart = await getCart();
      syncUI(cart);
      updateCartPageTotal(cart);
      updateMiniCartCheckoutTotal(cart);
    } catch (err) {
      console.error('[HOBIEGO Split Shipping] init error', err);
    }

    hookMiniCartOpen();
    hookMainCartRerender();
  });

  // ✅ bfcache / instant.page safety re-sync (MUST be inside this IIFE)
  window.addEventListener('pageshow', () => {
    getCart()
      .then(cart => {
        syncUI(cart);
        updateCartPageTotal(cart);
        updateMiniCartCheckoutTotal(cart);
      })
      .catch(() => {});
  });

})();

// =======================================================
// HOBIEGO — Header cart bubble count excludes Split Shipping fee
// Fixes flicker: theme briefly writes raw item_count (4) then we correct (3)
// This observer corrects the DOM immediately when it changes.
// Fee variant: 56318235509120
// =======================================================
(() => {
  const FEE_ID = 56318235509120;

  // Keep last known adjusted count so we can correct instantly
  let lastAdjusted = null;

  function adjustedCountFromCart(cart) {
    const raw = Number(cart?.item_count || 0);
    const feeQty = (cart?.items || []).reduce((sum, it) => {
      return sum + (Number(it?.id) === Number(FEE_ID) ? Number(it?.quantity || 0) : 0);
    }, 0);
    return Math.max(0, raw - feeQty);
  }

  function setAllBubbles(n) {
    document.querySelectorAll('cart-count.header__cart-count').forEach((el) => {
      const wanted = String(n);
      if (el.textContent !== wanted) el.textContent = wanted;
    });
  }

  async function fetchCartAndSet() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      lastAdjusted = adjustedCountFromCart(cart);
      setAllBubbles(lastAdjusted);
    } catch (e) {}
  }

  // 1) Apply ASAP (DOMContentLoaded)
  document.addEventListener('DOMContentLoaded', fetchCartAndSet);

  // 2) When Focal emits cart updates, update cache + set
  document.addEventListener('cart:updated', (event) => {
    const cart = event?.detail?.cart;
    if (cart) {
      lastAdjusted = adjustedCountFromCart(cart);
      setAllBubbles(lastAdjusted);
    } else {
      fetchCartAndSet();
    }
  });

  // 3) Instant anti-flicker: watch bubbles for any change and immediately correct
  function installObserver() {
    const obs = new MutationObserver(() => {
      if (lastAdjusted == null) return; // nothing cached yet
      setAllBubbles(lastAdjusted);
    });

    // Watch the whole document because header can be re-rendered / swapped
    obs.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true
    });

    // Also do a quick pass in case header appeared after load
    if (lastAdjusted != null) setAllBubbles(lastAdjusted);
  }

  installObserver();

  // 4) bfcache / instant.page safety
  window.addEventListener('pageshow', fetchCartAndSet);
})();





/* HOBIEGO — Quick Buy overlay fix (prevents clipping by overflow parents like .scroller)
   Detach to <body> while open, then reattach when closed.
*/
(() => {
  const store = new WeakMap();

  // Support both element names just in case theme swaps them
  const isQuickBuyEl = (el) =>
    el && (el.tagName === 'QUICK-BUY-DRAWER' || el.tagName === 'QUICK-BUY-POPOVER');

  function detach(el) {
    if (!el || store.has(el)) return;
    const parent = el.parentNode;
    if (!parent) return;

    const marker = document.createComment('hobiego-qb-marker');
    parent.insertBefore(marker, el);

    store.set(el, { parent, marker });
    document.body.appendChild(el);
  }

  function reattach(el) {
    const rec = store.get(el);
    if (!rec) return;

    rec.parent.insertBefore(el, rec.marker);
    rec.marker.remove();
    store.delete(el);
  }

  function sync(el) {
    if (!isQuickBuyEl(el)) return;
    const isOpen = el.hasAttribute('open');
    if (isOpen) detach(el);
    else reattach(el);
  }

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        sync(m.target);
      } else if (m.type === 'childList') {
        m.addedNodes.forEach((n) => {
          if (isQuickBuyEl(n)) sync(n);
          if (n?.querySelectorAll) {
            n.querySelectorAll('quick-buy-drawer, quick-buy-popover').forEach(sync);
          }
        });
      }
    }
  });

  mo.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['open'],
  });

  // Initial pass
  document.querySelectorAll('quick-buy-drawer, quick-buy-popover').forEach(sync);
})();



/* HOBIEGO — Quick Buy: hide Shop Pay + More options until the wallet stops remounting (quiet window) */
(() => {
  const state = new WeakMap();

  function getTargets(drawer) {
    const wallet = drawer.querySelector('shop-pay-wallet-button');
    const more = drawer.querySelector('.shopify-payment-button__more-options');
    return { wallet, more };
  }

  function show(drawer) {
    drawer.classList.remove('hobiego-hide-wallet');
    const s = state.get(drawer);
    if (!s) return;

    if (s.mo) s.mo.disconnect();
    if (s.raf) cancelAnimationFrame(s.raf);
    if (s.t) clearTimeout(s.t);

    state.delete(drawer);
  }

  function hideAndWaitForQuiet(drawer) {
    if (!drawer) return;

    // reset any previous watcher for this drawer
    const prev = state.get(drawer);
    if (prev) {
      if (prev.mo) prev.mo.disconnect();
      if (prev.raf) cancelAnimationFrame(prev.raf);
      if (prev.t) clearTimeout(prev.t);
      state.delete(drawer);
    }

    drawer.classList.add('hobiego-hide-wallet');

    const quietMs = 260;        // how long it must be "quiet"
    const hardTimeoutMs = 2500; // safety net so it never stays hidden forever
    const startedAt = performance.now();

    const s = { mo: null, t: null, raf: null, lastMut: performance.now() };
    state.set(drawer, s);

    const bump = () => { s.lastMut = performance.now(); };

    // Observe changes inside the drawer, but focus on the payment area if possible
    const { wallet } = getTargets(drawer);
    const observeRoot = wallet || drawer;

    s.mo = new MutationObserver(() => bump());
    s.mo.observe(observeRoot, { subtree: true, childList: true, attributes: true });

    // Also bump on resize/layout changes (iframe often resizes)
    const onResize = () => bump();
    window.addEventListener('resize', onResize, { passive: true });

    const cleanupResize = () => window.removeEventListener('resize', onResize);

    const stableHeight = () => {
      const { wallet, more } = getTargets(drawer);
      const wH = wallet ? wallet.getBoundingClientRect().height : 0;
      const mVis = more ? more.offsetParent !== null : true; // if missing, don't block
      return (wH > 10) && mVis;
    };

    // Require stability across TWO animation frames (prevents "one good frame" then swap)
    let stableFrames = 0;

    const tick = () => {
      const now = performance.now();

      // Hard timeout
      if ((now - startedAt) > hardTimeoutMs) {
        cleanupResize();
        show(drawer);
        return;
      }

      // Count stable frames only if:
      // 1) payment area has height
      // 2) no mutations for quietMs
      if (stableHeight() && (now - s.lastMut) >= quietMs) {
        stableFrames += 1;
      } else {
        stableFrames = 0;
      }

      if (stableFrames >= 2) {
        cleanupResize();
        show(drawer);
        return;
      }

      s.raf = requestAnimationFrame(tick);
    };

    s.raf = requestAnimationFrame(tick);
  }

  // Run when QUICK-BUY-DRAWER opens
  const moOpen = new MutationObserver((ms) => {
    for (const m of ms) {
      if (m.type === 'attributes' && m.attributeName === 'open' && m.target.tagName === 'QUICK-BUY-DRAWER') {
        const drawer = m.target;
        if (drawer.hasAttribute('open')) hideAndWaitForQuiet(drawer);
        else show(drawer);
      }
    }
  });

  moOpen.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();





// =======================================================
// HOBIEGO — Hide 'hidden-product' tagged items from predictive search
// DOM-based approach: removes hidden products after they render
// =======================================================
(() => {
  function removeHiddenProducts() {
    document.querySelectorAll('.predictive-search__product-item').forEach(item => {
      const link = item.querySelector('.product-item-meta__title');
      if (!link) return;
      // Check if the title matches the hidden product
      if (link.textContent.trim() === 'Split Shipping Fee') {
        item.remove();
      }
    });
  }

  const observer = new MutationObserver(removeHiddenProducts);
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true
  });
})();



/* HobiEgo — auto-dismiss cart notification after 3.5s */
(function () {
  var HIDE_MS = 3500;
  var timer;
  function arm() {
    var note = document.querySelector('cart-notification.cart-notification');
    if (!note) return;
    clearTimeout(timer);
    if (note.hasAttribute('hidden')) return;        // only when visible
    timer = setTimeout(function () {
      var close = note.querySelector('.cart-notification__close');
      if (close) close.click(); else note.setAttribute('hidden', '');
    }, HIDE_MS);
  }
  // Re-arm whenever the toast is shown (Focal toggles the [hidden] attribute)
  new MutationObserver(arm).observe(document.documentElement, {
    subtree: true, attributes: true, attributeFilter: ['hidden']
  });
  document.addEventListener('DOMContentLoaded', arm);
})();